// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';
import styled from 'styled-components';

// Components
import ButtonBase from 'app/shared/modules/MobileSRP/__BaseComponents__/Button';

// Hooks
import { useFilterChange } from 'app/shared/modules/MobileSRP/Header/FilterBar/hooks';

// Misc / utils
import { font } from 'app/shared/styles/_fontsize';

const StyledClearFiltersButton = styled(ButtonBase)`
  ${font.tiny};
`;

const ClearAllFiltersButton = () => {
  // Hooks
  const { resetFilter } = useFilterChange();

  const handleClearButtonClick = () => {
    resetFilter();
  };

  return (
    <StyledClearFiltersButton buttonType="link" onClick={handleClearButtonClick}>
      Clear all filters
    </StyledClearFiltersButton>
  );
};

export default ClearAllFiltersButton;
